import {getPocketVersion, useAppSelector, type PocketItem} from '@dv5/domain'
import React, {useEffect, useState} from 'react'
import {pocketService} from './services/pocketService'
import {PocketList} from './components/PocketList'
import PocketIcon from './components/pocket.svg?react'
import './PocketDisplay.less'

interface PocketDisplayProps {
    className?: string
    visible: boolean
    isListOpen: boolean
    setListOpen: (isOpen: boolean) => void
}

export const PocketDisplay: React.FC<PocketDisplayProps> = ({
                                                                className,
                                                                visible,
                                                                setListOpen,
                                                                isListOpen,
                                                            }) => {
    const [items, setItems] = useState<Array<PocketItem>>([])
    const [selectedIndex, setSelectedIndex] = useState<number | undefined>(undefined)
    const [showTooltip, setShowTooltip] = useState(false)
    const version = useAppSelector(getPocketVersion)

    const loadItems = () => {
        const pocketItems = pocketService.getPocketItems()
        setItems(pocketItems)
        setSelectedIndex(pocketService.getSelectedIndex())
    }

    useEffect(() => {
        loadItems()

        const handleStorageChange = (event: StorageEvent) => {
            if (event.key === 'dv5-pocket') {
                loadItems()
            }
        }

        window.addEventListener('storage', handleStorageChange)
        return () => {
            window.removeEventListener('storage', handleStorageChange)
        }
    }, [version])

    const itemCount = items.length

    const handleMouseEnter = () => {
        setShowTooltip(true)
    }

    const handleMouseLeave = () => {
        setShowTooltip(false)
    }

    const handleContainerClick = () => {
        setListOpen(true)
    }

    const handleCloseList = () => {
        setListOpen(false)
    }

    if (!visible && itemCount === 0) {
        return null
    }

    const classes = ['pocket-display-container']
    if (className) {
        classes.push(className)
    }

    const tooltip = pocketService.getTooltipText(itemCount)

    return (
        <>
            <button
                type="button"
                aria-label="Pocket"
                aria-haspopup="dialog"
                aria-expanded={isListOpen}
                className={classes.join(' ')}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
                onFocus={handleMouseEnter}
                onBlur={handleMouseLeave}
                onClick={handleContainerClick}
            >
                <span className='container'>
                    <PocketIcon/>

                    {itemCount > 0 && (
                        <span className="pocket-badge">{itemCount}</span>
                    )}

                    {showTooltip && (
                        <span className="pocket-tooltip" role="tooltip">{tooltip}</span>
                    )}
                </span>
            </button>

            {isListOpen && (
                <PocketList items={items} onClose={handleCloseList} selectedIndex={selectedIndex}/>
            )}
        </>
    )
}
